import { Component, Input } from '@angular/core';

@Component({
  selector: 'vfs-template-full',
  templateUrl: './template-full.component.html',
  styleUrls: ['./template-full.component.scss']
})
export class TemplateFullComponent {
  @Input() noPadding = false;
  @Input() noPaddingLeft = false;
  @Input() noPaddingRight = false;
  @Input() background = false;
}
